// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  about: dynamic(() => import("./About")),
  bouton: dynamic(() => import("./Bouton")),
  form: dynamic(() => import("./Form")),
  gallery: dynamic(() => import("./Gallery")),
  hero: dynamic(() => import("./Hero")),
  hero_project: dynamic(() => import("./HeroProject")),
  image: dynamic(() => import("./Image")),
  logo: dynamic(() => import("./Logo")),
  menu_item: dynamic(() => import("./MenuItem")),
  projects_preview: dynamic(() => import("./ProjectsPreview")),
  text_only: dynamic(() => import("./TextOnly")),
  video: dynamic(() => import("./Video")),
};
